/* Levitator buy cards: keep price, badge and button in sync with the inline variant dropdown. */
(function () {
  function bindCard(card) {
    var select = card.querySelector('[data-variant-select]');
    if (!select || select.dataset.bound) return;
    select.dataset.bound = 'true';
    select.addEventListener('change', function () {
      var opt = select.selectedOptions[0];
      var sale = card.querySelector('[data-price-sale]');
      var compare = card.querySelector('[data-price-compare]');
      var badge = card.querySelector('[data-badge]');
      var button = card.querySelector('.product-form__submit');
      if (sale) sale.textContent = opt.dataset.price;
      if (compare) { compare.textContent = opt.dataset.compare || ''; compare.hidden = !opt.dataset.compare; }
      if (badge) {
        if (opt.dataset.save) { badge.textContent = 'Save ' + opt.dataset.save + '%'; badge.hidden = false; }
        else if (!badge.textContent.trim()) { badge.hidden = true; }
      }
      if (button) {
        var available = opt.dataset.available === 'true';
        button.disabled = !available;
        var label = button.querySelector('span');
        if (label) label.textContent = available ? button.dataset.labelAvailable : button.dataset.labelSoldOut;
      }
    });
  }
  function init() { document.querySelectorAll('[data-buy-card]').forEach(bindCard); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
